import { css, SerializedStyles } from '@emotion/core';

import { Theme, secondaryText } from 'features/Theme';

const styles = {
  manualEntryContainer: (theme: Theme): SerializedStyles => css`
  ${secondaryText(theme)}
    margin-top: ${theme.mui.spacing(1)}px;
  `,

  manualEntryButton: (theme: Theme): SerializedStyles => css`
    font-size: inherit;
    color: ${theme.mui.palette.primary.main};
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    padding: 0px;
    font-weight: ${theme.mui.typography.fontWeightBold};
  `,
};

export default styles;
